var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDoubleOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 9.05713L20.2769 13.3333L19.3341 14.2761L16.0008 10.9427L12.6674 14.2761L11.7246 13.3333L16.0008 9.05713Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6674 17.7238L16.0008 21.0571L19.3341 17.7238L20.2769 18.6666L16.0008 22.9427L11.7246 18.6666L12.6674 17.7238Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleOut);
export default __webpack_public_path__ + "static/media/chevron-double-out.7aff93e8f1f2daa7e6322d6eb9f033e4.svg";
export { ForwardRef as ReactComponent };